import React, { useState } from "react";
import moment from "moment";
import { Checkbox,TableCell, TableRow, Tooltip, } from "@material-ui/core";
import { VisibilityOutlined, DeleteOutline, Edit } from '@material-ui/icons';
import RevertIcon from "../../../assets/images/Revert_Icon.svg"
import { checkPermission } from "../../../utils_v2";
import { trackActivity } from "../../../../utils/mixpanel";
import { displayDateFormat } from "../../../../constants";

const AircraftModelsList = ({ isModel, deleted, index, item, onEditFn, onViewFn, onDelete, onRevert, toggleBulkOps, bulkIds, unLink }) => {

    const [showMore, setShowMore] = useState({});
    const toggleDescription = (field) => {
        setShowMore({
            ...showMore,
            [field]: !showMore[field]
        })
    }

    return (
        <>
            <TableRow key={index} className={item?.deleted_at ? "grey-out" : ''}>
                {!isModel ? <TableCell>
                    <ul className="list-inline flex-centered" style={{ width: '130px' }}>
                        {checkPermission('config_data', 'aircraft_models', 'D') &&  <li className="list-inline-item hover-inline last-icon">
                            <Checkbox checked={bulkIds.includes(item?.id)} onChange={(e) => { toggleBulkOps(item, e.target.checked) }} color="primary" size="small" />
                        </li>}
                        <li className="list-inline-item hover-inline last-icon" style={{ marginTop: "5px" }}>
                            <Tooltip title='Veiw' arrow><VisibilityOutlined onClick={() => {onViewFn(); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Model', item_type: 'View Button', event_type: 'Item Clicked', event_desc: `Clicked on view button from Aircraft Model Listing` })}} color="primary" fontSize="small" /></Tooltip>
                        </li>
                        {!item?.deleted_at && checkPermission('config_data', 'aircraft_models', 'U')  ?
                            <li className="list-inline-item hover-inline" onClick={() => {onEditFn(); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Model', item_type: 'Edit Button', event_type: 'Item Clicked', event_desc: `Clicked on Edit button to open Edit Aircraft Modal` })}}>
                                <Tooltip title='Edit' arrow><Edit color="primary" fontSize="small" /></Tooltip>
                            </li>
                            : null}
                        {item?.deleted_at && checkPermission('config_data', 'aircraft_models', 'RVT')  ?
                            <li className="list-inline-item hover-inline">
                                <Tooltip title='Revert' arrow>
                                    <img
                                        src={RevertIcon}
                                        alt="Revert Icon"
                                        onClick={() => {onRevert({ modal: true, data: item?.id }); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Model', item_type: 'Revert Button', event_type: 'Item Clicked', event_desc: `Clicked on Revert button to open Revert Aircraft Modal` })}}
                                        style={{ width: "1rem", height: "1rem", cursor: 'pointer', fontSize: "1.25rem", margin:'4px' }}
                                        className="last-icon"
                                    />
                                </Tooltip>
                            </li>
                            : null}
                        {!item?.deleted_at && checkPermission('config_data', 'aircraft_models', 'D')?
                            <li className="list-inline-item hover-inline" onClick={() => {onDelete({ modal: true, data: item, }); trackActivity('Console Management', { page_title: 'Config Data : Aircraft Model', item_type: 'Delete Button', event_type: 'Item Clicked', event_desc: `Clicked on Delete button to open Delete Aircraft Modal` })}}>
                                <Tooltip title='Delete' arrow><DeleteOutline color="secondary" fontSize="small" /></Tooltip>
                            </li>
                            : null}
                    </ul>
                </TableCell> : !deleted ?
                    <TableCell>
                        {!item?.deleted_at ?
                        <ul className="list-inline flex-centered" style={{ width: '130px' }}>
                            {checkPermission('config_data', 'aircraft_models', 'D') &&   <> <li className="list-inline-item hover-inline last-icon">
                                <Checkbox checked={bulkIds.includes(item?.id)} onChange={(e) => { toggleBulkOps(item, e.target.checked) }} color="primary" size="small" />
                            </li>
                            <li className="list-inline-item hover-inline" onClick={() => unLink({ modal: true, data: item})}>
                                <Tooltip title='Unlink' arrow><DeleteOutline color="secondary" fontSize="small" /></Tooltip>
                            </li></>}
                        </ul> : null }
                    </TableCell> : null}
                <TableCell><div style={{ width: '150px' }}>{item?.name || '--'}</div></TableCell>
                <TableCell><div style={{ width: '150px' }}>{item?.ac_type?.name || '--'}</div></TableCell>
                <TableCell>
                    <div style={{ width: '150px' }}>
                        {item?.created_by?.name || '--'}
                        {item?.created_by?.name ?
                            <p style={{ fontSize: '11px', opacity: '0.8' }}>{moment(item?.created_at).format(displayDateFormat)}</p> : null
                        }
                    </div>
                </TableCell>
                <TableCell>
                    <div style={{ width: '150px' }}>
                        {item?.updated_by?.name || '--'}
                        {item?.updated_by?.name ?
                            <p style={{ fontSize: '11px', opacity: '0.8' }}>{moment(item?.updated_at).format(displayDateFormat)}</p> : null
                        }
                    </div>
                </TableCell>
                <TableCell>
					{item?.remarks && item?.remarks?.length > 30 ? (
						<div style={{ width: '200px' }}>
							{showMore[item?.field] ? (
								<span>
									<span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.replace(/\n/g, '<br />') }} />
									<a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}less </a>
								</span>
							) : (
								<span>
									<span dangerouslySetInnerHTML={{ __html: item?.remarks && item?.remarks.substring(0, 25).replace(/\n/g, '<br />'), }} />
									<a href="#" style={{ color: '#0E7FE1', fontSize: '12px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item.field); }} > {" "}..more </a>
								</span>
							)}
						</div>
					) : (
						<div dangerouslySetInnerHTML={{ __html: item?.remarks || '--', }} />
					)}
                </TableCell>
            </TableRow>
        </>
    )
}
export default AircraftModelsList;